    <!-- =========================================================================================
    File Name: StreamingStatisticsReport.vue
    Description: Streaming Statistice Report page
========================================================================================== -->

<template>
    <div id="demo-card-analytics">
        <!-- ROW 3 -->
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card :title="this.$t('MONTHLY_SUM_STREAMING_TIME')">
                    <div class="pl-5 pt-5">
                        <DatePicker lang="en" type="year" v-model="year" :format="datepickerFormat" width="60"></DatePicker>
                    </div>
                    <p class="float-right">{{this.$t("STREAMING_UNIT")}}</p>
                    <div class="pt-10 pb-0">
                        <vue-apex-charts type=line height=266 :options="chartOptions" :series="series" />
                        <p class="p-3 float-right text-base">{{this.$t("TIME_ZONE_MESSAGE")}}</p>
                        <br/>
                    </div>
                </vx-card>
            </div>
        </div>
    
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card :title="this.$t('SUM_STREAMING_TIME_BY_USER')">
                    <vs-button icon-pack="feather" icon="icon-download" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
                    <br />
                    <p class="p-3 float-right">{{this.$t("STREAMING_UNIT")}}</p>
                    <v-server-table id="streaming-duration-table" ref="streamingDurationTable" name="streamingDurationTable" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcel">
                    </v-server-table>
                    <p class="p-3 float-right">{{this.$t("TIME_ZONE_MESSAGE")}}</p>
                    <br/>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moduleReport from "@/store/report/moduleReport.js"
let FileSaver = require('file-saver');

export default {
    components: {
        VueApexCharts,
        DatePicker
    },
    data() {
        return {
            year: this.$moment(new Date).toDate(),
            datepickerFormat: 'YYYY',
            //Chart
            chartOptions: {
                chart: {
                    toolbar: { show: true },
                    dropShadow: {
                        enabled: true,
                        top: 20,
                        left: 2,
                        blur: 6,
                        opacity: 0.20
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 4,
                },
                grid: {
                    borderColor: '#ebebeb',
                },
                legend: {
                    show: false,
                },
                colors: ['#F97794'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        inverseColors: false,
                        gradientToColors: ['#7367F0'],
                        shadeIntensity: 1,
                        type: 'horizontal',
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100, 100, 100]
                    },
                },
                markers: {
                    size: 0,
                    hover: {
                        size: 5
                    }
                },
                xaxis: {
                    labels: {
                        style: {
                            cssClass: 'text-grey fill-current',
                        }
                    },
                    categories: [this.$t('JAN'), this.$t('FEB'), this.$t('MAR'), this.$t('APR'), this.$t('MAY'), this.$t('JUN'), this.$t('JUL'), this.$t('AUG'), this.$t('SEP'), this.$t('OCT'), this.$t('NOV'), this.$t('DEC')],
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    tickAmount: 5,
                    labels: {
                        style: {
                            cssClass: 'text-grey fill-current',
                        },
                        formatter: function(val) {
                            return val.toLocaleString()
                        }
                    },
                },
                tooltip: {
                    x: { show: true }
                }
            },
            // Table
            columns: ['userId', 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
            options: {
                perPage: 10,
                skin: 'table',
                filterByColumn: true,
                filterable: ['userId'],
                sortable:['userId', 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
                orderBy: { ascending: true },
                sortIcon: {
                    base: 'feather',
                    up: 'icon-arrow-up',
                    down: 'icon-arrow-down',
                },
                texts: {
                    filterBy: this.$t("FILTER_BY"),
                    defaultOption: this.$t("DEFAULT_OPTION"),
                },
                headings: {
                    'userId': () => this.$t("USER_ID"),
                    'jan': () => this.$t('JAN'),
                    'feb': () => this.$t('FEB'),
                    'mar': () => this.$t('MAR'),
                    'apr': () => this.$t('APR'),
                    'may': () => this.$t('MAY'),
                    'jun': () => this.$t('JUN'),
                    'jul': () => this.$t('JUL'),
                    'aug': () => this.$t('AUG'),
                    'sep': () => this.$t('SEP'),
                    'oct': () => this.$t('OCT'),
                    'nov': () => this.$t('NOV'),
                    'dec': () => this.$t('DEC'),
                },
                requestAdapter: function(data) {
                    return {
                        ascending: data.ascending,
                        byColumn: data.byColumn,
                        pageSize: data.limit,
                        orderBy: data.orderBy ? data.orderBy : "userId",
                        page: data.page,
                        query: data.query,
                        pageResult: ((data.page - 1) * data.limit)
                    };
                },
                requestFunction: (data) => {
                    let searchYear = this.year.getFullYear()
                    return this.$http.get(`/api/user-report/streaming-duration-by-user/${searchYear}`, {
                        params: data
                    }).catch(function(e) {
                        this.dispatch('error', e);
                        this.$vs.loading.close()
                    }.bind(this));
                },
                responseAdapter: (response) => {
                    this.$store.commit('dataReport/SET_STREAMING_DURATION_TABLE', response.data)
                    return {
                        data: this.$store.state.dataReport.streamingDurationReportList,
                        count: this.$store.state.dataReport.streamingDurationReportCount
                    }
                },
                 templates:{
                    userId: function(h,row){
                        return row.user.userId;
                    },
                    jan: function(h,row){
                        return row.monthlySum.january.toLocaleString();
                    },
                    feb: function(h,row){
                        return row.monthlySum.february.toLocaleString();
                    },
                    mar: function(h,row){
                        return row.monthlySum.march.toLocaleString();
                    },
                    apr: function(h,row){
                        return row.monthlySum.april.toLocaleString();
                    },
                    may: function(h,row){
                        return row.monthlySum.may.toLocaleString();
                    },
                    jun: function(h,row){
                        return row.monthlySum.june.toLocaleString();
                    },
                    jul: function(h,row){
                        return row.monthlySum.july.toLocaleString();
                    },
                    aug: function(h,row){
                        return row.monthlySum.august.toLocaleString();
                    },
                    sep: function(h,row){
                        return row.monthlySum.september.toLocaleString();
                    },
                    oct: function(h,row){
                        return row.monthlySum.october.toLocaleString();
                    },
                    nov: function(h,row){
                        return row.monthlySum.november.toLocaleString();
                    },
                    dec: function(h,row){
                        return row.monthlySum.december.toLocaleString();
                    },
                }
            }
        }
    },
    created() {
        if (!moduleReport.isRegistered) {
            this.$store.registerModule('dataReport', moduleReport)
            moduleReport.isRegistered = true
        }
        this.$vs.loading()
        this.$store.dispatch("dataReport/fetchStreamingDurationReport", this.year.getFullYear()).then(() =>{
                this.$vs.loading.close()
        })
    },
    watch: {
        year: function() {
            this.$vs.loading()
            this.$store.dispatch("dataReport/fetchStreamingDurationReport", this.year.getFullYear()).then(() =>{
                this.$vs.loading.close()
            })
            this.$refs.streamingDurationTable.getData()
        }
    },
    computed: {
        series() {
            return this.$store.state.dataReport.streamingDurationReportSeries
        },
    },
    methods: {
        exportExcel() {
            let locale = this.$i18n.locale
            let searchYear = this.year.getFullYear()

            this.$http({
                method: 'post',
                url: '/api/user-report/streaming-duration-by-user/excel/' + locale + '/' + searchYear,
                data: {
                    query: JSON.stringify(this.filterForExcel),
                    orderBy: this.sortForExcel.column ? this.sortForExcel.column : 'userId',
                    ascending: this.sortForExcel.ascending ? 1 : 0
                },
                responseType: 'blob',
                headers: {
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            }).then((response) => {
                let excelTitle
                if (locale === "ko") {
                    excelTitle = searchYear + "년_스트리밍_시간_합계_목록.xlsx"
                } else {
                    excelTitle = "Sum_of_streaming_duration_" + searchYear + ".xlsx"
                }
                FileSaver.saveAs(response.data, excelTitle)
            }).catch((error) => {
                console.log(error);
            })
        }
    },
}
</script>


<style lang="scss">
#demo-card-analytics {
    .tasks-today-container {
        .tasks-today__task {
            transition: background .15s ease-out;
            .tasks-today__actions {
                display: none;
            }
            &:hover {
                background: rgba(var(--vs-primary), .04);
                .tasks-today__actions {
                    display: flex;
                }
            }
        }
    }
}

#streaming-duration-table {
    text-align: center;
}
</style>
